import { createContext, useState, useEffect } from 'react';
import { canonicalRole } from './utils/roleUtils';
import api from './api/axiosInstance';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true); // Add loading state

    useEffect(() => {
        let storedUser = null;

        try {
            storedUser = JSON.parse(localStorage.getItem('user') || 'null');
        } catch {
            storedUser = null;
        }

        if (storedUser?.role) {
            storedUser.role = canonicalRole(storedUser.role); // ✅ normalize once
        }

        let cancelled = false;
        if (!storedUser) {
            setLoading(false);
            return;
        }
        // The stored user is a cache; routing on reload uses current server state.
        api.get('/api/users/me').then(({ data }) => {
            if (cancelled) return;
            const currentUser = { ...data, role: canonicalRole(data.role) };
            localStorage.setItem('user', JSON.stringify(currentUser));
            setUser(currentUser);
        }).catch((error) => {
            if (cancelled) return;
            if (error?.response?.status !== 401) setUser(storedUser);
        }).finally(() => {
            if (!cancelled) setLoading(false);
        });
        return () => { cancelled = true; };
    }, []);

    return (
        <UserContext.Provider value={{ user, setUser, loading }}>
            {children}
        </UserContext.Provider>
    );
};
